var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.7 9.7-7.6 7.6c-.4.4-1 .4-1.4 0l-3.5-3.5c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l2.7 2.7 6.9-6.9c.4-.4 1-.4 1.4 0 .5.5.5 1.1.1 1.5"
  })));
};
export default SvgCheck;